import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=31f67132&scoped=true&"
var script = {}
import style0 from "./style.css?vue&type=style&index=0&id=31f67132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f67132",
  null
  
)

export default component.exports